import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { Home } from "./paginas/index";
import { Desarrollo } from "./paginas/desarrollo";
import { Infraestructura } from "./paginas/infraestructura";
import { useEffect } from "react";
import { Footer } from "./componentes/footer";

function App() {
  const location = useLocation();

  // Desplazamos la página al inicio cada vez que la ruta cambia
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/desarrollo" element={<Desarrollo />} />
        <Route path="/infraestructura" element={<Infraestructura />} />
      </Routes>
    <Footer></Footer>
    </>
  );
}

export default App;
